import ServiceLocator from "../../../global/service-locator";
import MainController from "./main-controller";
import Controls from "./pages/question";
import FormPage from "./pages/form";
import ResultPage from "./pages/result";
import InitialPage from "./pages/initial";

export default class SpecialEventQuiz {
	constructor() {
		/* HTML elements */
		this.$root = document.getElementById('modalSpecialEventQuiz');
		this.$openBtn = document.getElementById('modalSpecialEventQuizTrigger');
		this.$page = null;

		/* Components */
		this.sl = ServiceLocator.instance;
		this.mainController = null;
		this.router = null;

		/* General info */
		this.config = craft.page.specialEventConfig;
		this.courseId = 'special-event';
		this.isInitialized = false;
		this.currentPageNumber = 1;
		this.isMobile = window.matchMedia('(max-width: 499px)').matches;
		this.isMultipleQuiz = this.config.items.length > 1;

		/* Pages Config Object */
		this.pages = null;

		/* Auto-init */
		this.init();
	}

	init() {
		if (this.config.status) {
			this.getElements();
			this.initComponents();

			this.sl.modalService.register('special-event-quiz', this.$openBtn, {
				hash: 'special-event',
				rootClass: this.isMobile ? 'bg-white' : '',
				beforeOpen: () => {
					this.open();
					location.hash = 'special-event';
				},
				afterClose: () => {
					this.handleClose();
				}
			});
		}
	}

	getElements() {
		this.$page = {
			initial: this.$root.querySelector('.quiz-page.-initial'),
			question: this.$root.querySelector('.quiz-page.-main'),
			form: this.$root.querySelector('.quiz-page.-form'),
			result: this.$root.querySelector('.quiz-page.-result')
		};
	}

	initComponents() {
		this.mainController = new MainController(
			this.$root,
			this.config.items.length === 2,
			this.checkIfFirstSession(),
			this.courseId
		);
		this.setupPageManager();
		this.setupPagesIterator();
	}

	setupPageManager() {
		this.page = {
			initial: {
				index: 1,
				$elem: this.$page.initial,
				controller: new InitialPage(
					this.$page.initial,
					this.mainController
				)
			},
			question: {
				index: 2,
				$elem: this.$page.question,
				controller: new Controls(
					this.$page.question,
					this.mainController
				)
			},
			form: {
				index: 3,
				$elem: this.$page.form,
				controller: new FormPage(
					this.$page.form,
					this.mainController
				)
			},
			result: {
				index: 4,
				$elem: this.$page.result,
				controller: new ResultPage(
					this.$root,
					this.mainController
				)
			}
		}
	}

	setupPagesIterator() {
		this.pageIterator = new Map();
		this.pageIterator.set(this.page.initial.index, this.page.initial);
		this.pageIterator.set(this.page.question.index, this.page.question);
		this.pageIterator.set(this.page.form.index, this.page.form);
		this.pageIterator.set(this.page.result.index, this.page.result);
	}

	open() {
		if (!this.isInitialized) {

			this.bootstrap(this.config.items[0]);
			this.isInitialized = true;

		}

		this.mainController.animation.init(this.pageIterator.size, this.currentPageNumber);
	}

	handleClose() {
		if (this.isInitialized && this.currentPageNumber === this.pageIterator.size) {
			this.mainController.init(() => {
				this.currentPageNumber = this.mainController.isFinished ? 1 : 2;
				this.switchPage('initial', this.currentPageNumber);
				setTimeout(() => {
					this.mainController.toggleProgressOverlay('hide');
				}, 1000);
				this.mainController.animation.$real.removeAttribute('style');
			}, this.config.items[0], true);
		}

		this.mainController.animation.toggleWillChange('remove');
	}

	bootstrap(config) {
		this.mainController.init(storage => {
			if (storage) {
				const data = storage.getLocalStorage();

				if (data && data['special-event-quiz'] &&
					data['special-event-quiz'].data.questionList[0].isAnswerCorrect != null &&
					!data['special-event-quiz'].result
				) {
					this.currentPageNumber = 2;
				}
			}

			const currentPageManager = this.pageIterator.get(this.currentPageNumber);
			this.mainController.animation.switchShuffleActive(this.currentPageNumber);

			if (this.currentPageNumber > 1) {
				this.mainController.animation.showFakePages();
			}

			this.bootstrapInitialPage(currentPageManager.controller);

			setTimeout(() => {
				this.mainController.toggleProgressOverlay('hide');
			}, 1000);
		}, config);
	}

	bootstrapInitialPage(pageController) {
		pageController.init((direction, pageNum) => {
			this.switchPage(direction, pageNum);
		});
	}

	switchPage(pageSwitchingType, pageNum = null) {
		pageSwitchingType = (
			pageSwitchingType === 'next' ||
			pageSwitchingType === 'prev' ||
			pageSwitchingType === 'initial' ||
			pageSwitchingType === 'simple'
		) ? pageSwitchingType : 'next';

		if (pageSwitchingType === 'next') {
			this.currentPageNumber++;
		} else if (pageSwitchingType === 'prev') {
			this.currentPageNumber--;
		}
		
		if (pageNum) this.currentPageNumber = pageNum === 'last' ? this.pageIterator.size : pageNum;

		this.mainController.animation.switchShuffleActive(this.currentPageNumber);
		const currentPageManager = this.getCurrentPageManager();

		// if (this.currentPageNumber === 1) {
		// 	this.mainController.toggleProgressOverlay('show');
		// }

		this.mainController.animation[pageSwitchingType](() => {
			currentPageManager.controller.init((direction, pageNum) => {
				this.switchPage(direction, pageNum);
			});
		});
	}

	getCurrentPageManager() {
		return this.pageIterator.get(this.currentPageNumber);
	}

	checkIfFirstSession() {
		const entryIdList = craft.page.specialEventConfig.items.map(item => item.entryId);
		const storageData = JSON.parse(localStorage.getItem(document.querySelector('html').getAttribute('lang') + '_quiz_' + this.courseId));
		let isFirstSession = true;

		if (storageData) {
			entryIdList.forEach(entryId => {
				if (
					storageData.hasOwnProperty(entryId) &&
					storageData[entryId].hasOwnProperty('result')
				) {
					isFirstSession = false;
				}
			});
		}

		return isFirstSession;
	}
}